import {AnyAction} from 'redux';
import {LOCATION_CHANGE} from 'redux-first-history';

import * as at from './hierarchy_action_types';
import {HierarchyTypes} from 'src/js/model/hierarchy';

const defaultState = {
  hierarchyTypes: new HierarchyTypes(),
  locationState: {
    locationParsed: false,
    reload: false,
  },
  selectorLocationState: {
    locationParsed: false,
    reload: false,
  },
};

function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case LOCATION_CHANGE: {
      const {action: locationAction, query} = action.payload;
      if (
        action.payload &&
        (locationAction === 'POP' || (query && query.reload === 'true'))
      ) {
        let newState = {...state};
        if (newState.locationState.locationParsed) {
          newState = {
            ...newState,
            locationState: {
              ...newState.locationState,
              reload: true,
              locationParsed: false,
            },
          };
        }
        if (newState.selectorLocationState.locationParsed) {
          newState = {
            ...newState,
            selectorLocationState: {
              ...newState.selectorLocationState,
              reload: true,
              locationParsed: false,
            },
          };
        }
        return newState;
      }
      break;
    }
    case at.LOCATION_PARSED: {
      return {
        ...state,
        ...(state.locationState.locationParsed !== action.payload
          ? {
              locationState: {
                ...state.locationState,
                locationParsed: action.payload,
              },
            }
          : {}),
      };
    }
    case at.RESET_RELOAD: {
      return {
        ...state,
        ...(state.locationState.reload !== action.payload
          ? {
              locationState: {
                ...state.locationState,
                reload: action.payload,
              },
            }
          : {}),
      };
    }
    case at.SELECTOR_LOCATION_PARSED: {
      return {
        ...state,
        selectorLocationState: {
          ...state.selectorLocationState,
          locationParsed: action.payload,
        },
      };
    }
    case at.SELECTOR_RESET_RELOAD: {
      return {
        ...state,
        selectorLocationState: {
          ...state.selectorLocationState,
          reload: action.payload,
        },
      };
    }
    case at.HIERARCHY_TYPES_FETCH_SUCCESS: {
      if (action.payload && !state.hierarchyTypes.isLoaded()) {
        return {...state, hierarchyTypes: action.payload};
      }
      break;
    }
  }
  return state;
}

export default reducer;
